<script lang="ts">
    import FauxInput from "./FauxInput.svelte";
</script>

<header>
    <div class="title">
        <h1>
            <span class="seeing">Seeing Like a</span>
            <span class="software">
                <div class="box" />
                Software
            </span>
        </h1>
    </div>
    <div class="info">
        <div class="left">
            <FauxInput marginRight label="created_by:">
                <a href="https://katmh.com">Kat Huang</a>
            </FauxInput>
            <FauxInput label="created_at:">September 2021</FauxInput>
        </div>
        <div>
            <FauxInput italicizeLabel label="extends">
                <a href="https://experientialethics.mit.edu/home"
                    >MIT Experiential Ethics</a
                >
            </FauxInput>
        </div>
    </div>
</header>

<style>
    header {
        width: 100%;
        background: #222;
        padding: 0 2.5rem 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
    }

    .title {
        padding: 12.5rem 0 12rem;
    }

    h1 {
        text-transform: lowercase;
        text-align: center;
    }

    .seeing {
        color: #9c9;
        font: 400 3.5rem/1 Crimson Text, Georgia, serif;
    }

    .software {
        color: #3c6;
        font: 700 3.25rem/1 IBM Plex Mono, Monaco, monospace;
        position: relative;
    }

    .box {
        border: 1px solid #aaa;
        width: 10rem;
        height: 10rem;
        position: absolute;
        top: 0;
        left: 2.5rem;
        transform: translate(0, -25%);
    }

    .info {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        max-width: 1200px;
        margin: auto;
    }

    .info .left {
        display: flex;
    }

    a {
        color: #eee;
    }
</style>
